<template>
  <button @click.prevent="clickHandler">
    <svg x="0px" y="0px" width="44px" height="44px" viewBox="0 0 44 44" xml:space="preserve">
      <slot :position="position">
        <text :transform="position" font-family="san-serif" font-size="16">menu</text>
      </slot>
      <slot name="icon">
        <rect fill="currentColor" x="0" y="0" width="44px" height="5px"/>
        <rect fill="currentColor" x="0" y="10" width="44px" height="5px"/>
        <rect fill="currentColor" x="0" y="20" width="44px" height="5px"/>
      </slot>
    </svg>
  </button>
</template>

<script>
  export default {
    props: {
      clickHandler: {
        type: Function,
        required: true,
      },
    },
    data() {
      return {
        position: 'matrix(1 0 0 1 0.1514 41)',
      }
    },
  }
</script>


<style lang="scss" scoped>

  @import '../../sass/partials/config';
  @import '../../sass/partials/functions';

  button {
    background-color: transparent;
    border: 0;
    padding: .7em .55em .45em;
    position: absolute;
    right: 0;
    text-transform: uppercase;
    top: .73em;

    @include respond-to(lap) {
      display: none;
    }

    &:hover {
      background-color: rgba(black, .1);
    }

    svg {
      display: block;
      height: 26.4px;
      pointer-events: none;
      width: 26.4px;
    }

    .is-open & {
      svg {
        opacity: .5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// sportspower/assets/es6/components/MenuButton.vue